import styled from 'styled-components';

export const ErrorMessage = styled.div`
  color: #ff2f2f;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  padding: 40px 0 0;
  text-align: center;
`;
